<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div class="form-box">
        <div class="form-box-top">
          <img class="image-logo" src="@/assets/images/logo.png" alt="logo" />
          <hr class="hr">
          <br>
          <el-row :gutter="10">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><b class="member-portal">FORGET PASSWORD</b></el-col>
          </el-row>
          <br>
          <div class="remindInfo">Please enter your login account and email address，we will send you a new password by email</div>

          <br>
          <float-label class="styled">
						<input type="email"  placeholder="Enter Your Email" v-model="email" v-focus @focus="isFocus">
            <span class="err" v-show="isErr1">请输入正确的邮箱</span>
					</float-label>
          <br>
          <el-row :gutter="10">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <float-label class="styled">
                <input type="text" placeholder="Verification Code" v-model="verificationCode" v-focus @focus="isFocus2">
                 <span class="err" v-show="isErr2">请输入正确的验证码</span>
              </float-label>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-right">
              <img src="@/assets/images/code.jpg" alt="">
            </el-col>
          </el-row>

          <div class="text-center">
            <el-button plain size="small" class="reset-btn reset" @click="resetPwd" >RESET PASSWORD</el-button>
            <el-button plain size="small" class="reset-btn back" @click="back">BACK</el-button>
          </div>
        </div>
        <div class="form-box-bottom">
          <div class="text-center">

          </div>

          <div class="text-center text-white"><small>© 2017 EDDID.COM</small></div>

          <div class="text-center signin-box pt-20">
            <a class="text-orange">Privacy Policy |</a>
            <a class="text-orange"> Cookies Policy |</a>
            <a class="text-orange"> Terms and Conditions</a>
          </div>
        </div>

      </div>
    </div>
  </vue-scroll>
</template>
<script>
export default {
  name: 'ForgotPassword',
  data() {
     return {
      email: '',
      verificationCode:'',
      isErr1: false,
      isErr2:false
    }
  },
  methods: {
    isFocus(){
      this.isErr1 = false
    },
    isFocus2(){
      this.isErr2 = false
    },
    resetPwd() {
      let reg = /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/gi
      let code = /^mpmq$/gi
      if (!this.email && !this.verificationCode) {
        this.isErr1 = true
        this.isErr2 = true
      }else if(!reg.test(this.email)){
        this.isErr1 = true
      }
      else if(!code.test(this.verificationCode)) {
        //验证码
        this.isErr2 = true
      } else {
        this.$message.success('重置链接已成功发送至您的邮箱')
        this.isErr = false
        //刷新验证码，跳转页面
        this.$router.replace('/successInfo')
      }
    },
    async back () {
      this.$router.push('/login')
    },
  }
}
</script>
<style lang="scss">
@import '../../../assets/scss/_variables';
.remindInfo {
  font-size: 14px;
}
.text-white {
  color: #fff;
}
.text-orange {
  color: #fec000;
}
.hr {
  margin: 40px 0 20px;
  border: 1px solid #e2e2e2;
}
.member-portal {
  border-left: 4px solid #fec000;
  padding-left: 8px;
}
.forgot-password {
  margin-bottom: 16px;
}
.form-box-top {
  padding: 30px;
  background: #fff;
  border-radius: 4px 4px 0 0;
}
.form-box-bottom {
  padding: 30px;
  background: #192b57;
  border-radius: 0 0 4px 4px;
}
.reset{
  background: #fec000 !important;
  color: #192b57 !important;
  margin:25px 0 20px !important;
}
.back{
  border: 1px solid #192b57 !important;
  color:#192b57 !important;
  margin-bottom: 40px !important;
  margin-left: 0 !important;
}
.login-page {
  background-image: url(https://portal-responsive-client-uat.atfx.com/img/Landing-bg.bb9b7b96.png);
  background-size: 100% 100%;
  margin-left: -30px;
  margin-right: -30px;

  .form-wrapper {
    width: 100%;
  }

  .form-box {
    width: 100%;
    max-width: 460px;
    padding: 0;
    box-sizing: border-box;
    margin: 20px auto;

    a {
      font-size: 14px;
      font-weight: 500;
    }

    .image-logo {
      width: 156px;
      margin: 0px auto;
      margin-bottom: 30px;
      display: block;
    }
    .err {
      margin-top: 2px;
      color: #ec205f;
      font-size: 14px;
    }
    .reset-btn {
      width: 250px;
      border-radius: 6px;
      padding: 20px 0;

      &.login {
        background-color: #192b57;
        color: white;
        margin: 30px 0 20px;
      }
      &.signup {
        background-color: #fec000;
        color: #192b57;
        margin: 0 0 20px;
      }
    }

    .signin-box {
      font-size: 14px;
    }
  }
}

@media (max-width: 768px) {
  .layout-container .container .view.login-page {
    margin-left: -5px;
    margin-right: -5px;
    max-width: calc(100% + 10px);
  }
  .member-portal {
    font-size: 0.5rem;
  }
}
</style>

<!--<style lang="scss">
@import '../../../assets/scss/_variables';

.forgot-password-page {
	background: $text-color;
	margin-left: -30px;
	margin-right: -30px;

	.form-wrapper {
		width: 100%;
	}

	.form-box {
		width: 100%;
		max-width: 340px;
		padding: 30px;
		box-sizing: border-box;
		margin: 20px auto;

		a {
			font-size: 14px;
			color: $text-color-accent;
			text-decoration: none;
			font-weight: 500;
		}

		.image-logo {
			width: 80px;
			margin: 0px auto;
			margin-bottom: 50px;
			display: block;
		}
		.err {
			margin-top: 2px;
			color: #ec205f;
			font-size: 14px ;
		}
		.send-btn {
			width: 160px;
		}
	}
}

@media (max-width: 768px) {
	.layout-container .container .view.forgot-password-page {
		margin-left: -5px;
		margin-right: -5px;
		max-width: calc(100% + 10px);
	}
}
</style>-->
